import React from 'react';
import {Link} from 'react-router-dom';

export default class OrganizationCourses extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            courseList: []
        }
    }
    componentDidMount()
    {
        this.loadOrgCourses();
    }
    loadOrgCourses()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "LoadOrgCourseList",
            method: "get",
            success: result => {
                this.setState({
                    loaded: true,
                    courseList: result.orgCourses
                })
            },
            error: err => {
                this.setState({loaded: true});
            }
        })
    }
    render()
    {
        console.log(this.state.courseList);
        return (
            <div>
                {this.state.loaded ? (
                    <div style={{marginTop: "10px"}}>
                    <table className="lmstable" style={{marginTop: "12px"}}>
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Users Attempted</th>
                                <th>Actions</th>
                            </tr>
                            {this.state.courseList.length === 0 ? (
                                <tr>
                                    <td colSpan="4">
                                        <i>No course attempts have been made.</i>
                                    </td>
                                </tr>
                            ) : null}
                            {this.state.courseList.map(course => 
                                <tr key={course.courseID}>
                                    <td>{course.courseName}</td>
                                    <td>{course.courseDescription}</td>
                                    <td>{course.usersAttempted}</td>
                                    <td>
                                        <Link to={"/OrgUserCourse/" + course.courseID} className="lmsbutton">View User Results</Link>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>                            
                </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/organizationcourses.js